import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import WebinarOverview from './WebinarOverview';
import { Icon } from 'in-touch-icons';
import Anchor from "../../../../../../dashboardNew/objects/Anchor";
import {siteOfOriginHelper} from "../../../../../../../helpers/genericHelpers";
import { RichText } from 'prismic-reactjs';

class WebinarInfo extends Component {

    render() {
        const siteOfOrigin = siteOfOriginHelper();     
        const webinar = this.props.webinarPrismic && this.props.webinarPrismic.webinarsList[0];
        const showDoc = webinar && webinar.document ? true : false

        return (
            <div className="col-12 col-lg-4 webinar-cta">
                <div className="cta-head">
                    <h3 className="heading-three">Webinar</h3>
                    {
                       showDoc && <Anchor path={webinar.document} anchorClass={'pdf-button'} target>
                        <img className="pdf-image" src="/images/icons-new/file.svg"/>
                        Download Brochure
                    </Anchor>
                    }
                </div>
                { webinar && RichText.render(webinar.copy)}
                { this.props.webinarPrismic && 
                <div className="web-cta-bottom">
                    <h3 className="heading-two">
                        {webinar.currency}
                        {new Intl.NumberFormat('en-IN', {
                            minimumFractionDigits: 2,
                        }).format(webinar.price)}

                        {siteOfOrigin === 'gb' ? <span className="price-plus">+ VAT</span> : null}
                    </h3> 
                    <Link
                        className="theme-button"
                        data-toggle="modal"
                        data-target="#addToBasket">
                        <Icon iconName={'basket'} />
                        Buy Package
					</Link>
                </div>
                }
            </div>
        );
    }
}

WebinarOverview.propTypes = {
    webinar: PropTypes.object.isRequired,
};

export default WebinarInfo;



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/WebinarInfo.js